import { HttpErrorResponse } from "@angular/common/http";
import { AppStatus } from "@app/models";
import { ERROR_STRINGS, GLOBAL_ERROR_MESSAGES, StatusCode } from "@app/shared";

export class ErrorService {

  private readonly genericUnknownErrorMessage = GLOBAL_ERROR_MESSAGES.GENERIC_UNKNOWN_ERR_MSG;
  private readonly unknownDatabaseError = ERROR_STRINGS.SEQUELIZE;

  constructor(
    private readonly errorResponse: HttpErrorResponse
  ) {}

  handleError() {
    let errorCode = this.errorResponse.status;
    //Let's include all the required status code to take care of server errors. 
    switch (true) {
      case ((StatusCode.Badrequest <= errorCode) && (errorCode < StatusCode.ServerError)): {
        let errorMsg = this.parseError();
        if (errorMsg.includes(this.unknownDatabaseError)) {
          errorMsg = this.genericUnknownErrorMessage;
        }
        return errorMsg;
      }
      default:
        return this.genericUnknownErrorMessage;
    }
  }

  parseError() {
    let error = this.errorResponse?.error
    if(error?.error?.name) {
      let errorMessage = error?.error?.name
      // Notes: Backend team will be changing status code to 500 for the database exception. 
      // In future, if status code is 500 will display the generic message in handleError method.
      // Remove the below code once server able to handle all the database exceeption
      if(errorMessage.includes(this.unknownDatabaseError)) {
        return this.genericUnknownErrorMessage;
      }
      return error?.error?.name;
    } else if (error?.message) {
      return error?.message;
    }  else if (error?.error) {
      return error?.error;
    }  
    return this.genericUnknownErrorMessage;
  }

  parsePageError(): AppStatus {
    return { 
      status: `${this.errorResponse.status}. ${GLOBAL_ERROR_MESSAGES.GENETIC_ERROR_TITLE}`, 
      message: this.parseError(), 
      showNote: true
    };
  }

}

